import React, { useEffect, useState, useRef } from "react";
import Game from './Games';
import GamesModal from './GamesModal';
import { useNavigate } from "react-router-dom";
import { Variables, variables } from '../../Variables.js';

function Gametoolbar() {

    const [games, setState] = useState([])
    const navigate = useNavigate()
    const [pageIndex, setPageIndex] = useState(0);
    const [gamesPerPage, setGamesPerPage] = useState(4);
    const [selectedGame, setSelectedGame] = useState(null);

    function convertTo24Hour(time) {
        let [hours, modifier] = time.split(':');
        let [minutes, part] = modifier.split(/(a|p)/);

        if (hours === '12') {
            hours = '00';
        }

        if (part === 'p') {
            hours = parseInt(hours, 10) + 12;
        }

        return `${hours}:${minutes}`;
    }

    function compareGameTimes(a, b) {
        const timeA = convertTo24Hour(a.gameTime);
        const timeB = convertTo24Hour(b.gameTime);

        return timeA.localeCompare(timeB);
    }

    //(GET)
    const fetchTodaysGames = () => {
        fetch(variables.API_URL + 'Stats/getTodaysGames')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch todays games');
                }
                return response.json()
            })
            .then(data => {
                const sortedGames = data.sort(compareGameTimes);
                setState(sortedGames)
                //document.write(JSON.stringify(data));
            }).catch(error => {
                console.error("Error fetching todays games: ", error);
                navigate('/error');
            });

    }

    useEffect(() => {
        fetchTodaysGames();
    }, [])

    // Effect hook to handle window resize events
    useEffect(() => {
        const handleResize = () => {
            // Set number of games per page based on screen width
            if (window.innerWidth < 480) {
                setGamesPerPage(1); // for very small screens, show 1 game per page
            } else if (window.innerWidth < 768) {
                setGamesPerPage(2); // for small screens, show 2 games per page
            } else {
                setGamesPerPage(4); // for larger screens, show 5 games per page
            }
        };

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Call the handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const totalPages = Math.ceil(games.length / gamesPerPage);

    const nextGames = () => {
        setPageIndex((prev) => (prev + 1 < totalPages ? prev + 1 : prev));
    };

    const prevGames = () => {
        setPageIndex((prev) => (prev - 1 >= 0 ? prev - 1 : prev));
    };

    const handleGameClick = (game) => {
        setSelectedGame(game);
    };

    const handleCloseModal = () => {
        setSelectedGame(null);
    };

    const isPrevDisabled = pageIndex <= 0;
    const isNextDisabled = pageIndex + 1 >= totalPages;

    // Calculate the slice of games to display
    const visibleGames = games.slice(pageIndex * gamesPerPage, (pageIndex + 1) * gamesPerPage);

    return (
        <div className="gametoolbar-container">
            {games.length > 0 && (
                <>
                    <button className={`gametoolbar-button gametoolbar-button-prev ${isPrevDisabled ? 'disabled' : ''}`} onClick={prevGames} disabled={isPrevDisabled}>{'<'}</button>
                    <div className="gametoolbar">
                        {visibleGames.map((game, index) => (
                            <Game key={index} game={game} onClick={handleGameClick} />
                        ))}
                    </div>
                    <button className={`gametoolbar-button gametoolbar-button-prev ${isNextDisabled ? 'disabled' : ''}`} onClick={nextGames} disabled={isNextDisabled}>{'>'}</button>
                    {selectedGame && <GamesModal game={selectedGame} onClose={handleCloseModal} />}
                </>
            )}
        </div>

    );
};

export default Gametoolbar;
